module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAhUlEQVQ4T6WS0RFAMBBEnw6UQGXoQCk6QGWUoARzJvfh5JAkX5lM3t7uzVYUnKqAJRVugF0HWvgARmCJOOqBGWhVwML6YTAC0feYbfvRE3QzKyD25W6dXKneFiZgB6xB4LEGD9bJAorA78nZmbO3LQXYPIsh9wTUXkluDfqqbmo9b3pF8Ame4CEQd4dvHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/close.png
// module id = xp5Z
// module chunks = 1